
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/credit-card-consent-agreement",
      function () {
        return require("private-next-pages/credit-card-consent-agreement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/credit-card-consent-agreement"])
      });
    }
  